import { render, staticRenderFns } from "./ageManage.vue?vue&type=template&id=f01f6b86&scoped=true"
import script from "./ageManage.vue?vue&type=script&lang=js"
export * from "./ageManage.vue?vue&type=script&lang=js"
import style0 from "./ageManage.vue?vue&type=style&index=0&id=f01f6b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01f6b86",
  null
  
)

export default component.exports